module.exports = __webpack_public_path__ + "img/tubiao3_334_334.1226d3e3.png";